import { render, staticRenderFns } from "./TopBanner.vue?vue&type=template&id=3f4fbb58&scoped=true&"
import script from "./TopBanner.vue?vue&type=script&lang=js&"
export * from "./TopBanner.vue?vue&type=script&lang=js&"
import style0 from "./TopBanner.vue?vue&type=style&index=0&id=3f4fbb58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4fbb58",
  null
  
)

export default component.exports